const options = {
  removeItems: false,
  removeItemButton: false,
  searchEnabled: false,
  shouldSort: false,
  resetScrollPosition: false,
  loadingText: ``,
  noResultsText: 'Inga resultat',
  noChoicesText: 'Inga alternativ',
  itemSelectText: 'Klicka för att välja',
  addItemText: (value) => {
    return `Klicka för att välja <b>“${value}”</b>`;
  },
};

export default options;
